import React, { useEffect, useState } from "react";
import "./Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Form,
  InputGroup,
  Nav,
  Navbar,
  Offcanvas,
  Dropdown,
} from "react-bootstrap";
import {
  faBell,
  faBoxOpen,
  faCartShopping,
  faHeart,
  faMagnifyingGlass,
  faPhone,
  faRightFromBracket,
  faShieldHalved,
  faSortDown,
  faUser,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Search_Product_Offcanvas from "./search_product_offcanvas/Search_Product_Offcanvas";
import Common_Category_Offcanvas from "../common_components/common_category_offcanvas/Common_Category_Offcanvas";
import { useDispatch, useSelector } from "react-redux";
import {
  appSetup,
  getAllCategories,
  getAllSubCategory,
} from "../../features/master/masterSlice";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";
import Login_Modal from "../common_components/common_modal/login_flow/login_modal/Login_Modal";
import Reset_Password_Modal from "../common_components/common_modal/login_flow/reset_password_modal/Reset_Password_Modal";
import Set_New_Password_Modal from "../common_components/common_modal/login_flow/set_new_password_modal/Set_New_Password_Modal";
import { getAllCart } from "../../features/cart/cartSlice";
import { myAccount } from "../../features/my_account/Slice";
import Common_Hospitality_Offcanvas from "../common_components/common_category_offcanvas/Common_Hospitality_Offcanvas";
import { getHomeHeader } from "../../features/home/homeSlice";

function Header() {
  const [showCategory, setShowCategory] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const [showHospitality, setShowHospitality] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [openMega, setOpenMega] = useState(false);
  const [email, setEmail] = useState();
  const [contact, setContact] = useState();
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);

  useEffect(() => {
    const handleClickOutside = () => {
      setOpenMega(false);
      setShowCategory(false);
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const location = useLocation();
  const currentPath = location.pathname;
  const isActive = (path) => currentPath === path;
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const searchValue = queryParams.get("search");
  const [isLogedIn, setIsLogedIn] = useState(false);

  const [selectedCategory, setSelectedCategory] = useState(0);

  const notifications = [];

  const handleCategoryClick = () => {
    setShowCategories(true);
  };

  const handleHospitalityClick = () => {
    setShowHospitality(true);
  };

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/about-us", label: "About Us" },
    { path: "/store-location", label: "Locate Store" },
      {
      path: "/material",
      label: "Material",
    },
    {
      path: "/#",
      label: "Category",
      dropdown: true,
      onClick: handleCategoryClick,
    },
    // {
    //   path: "/#",
    //   label: "Accessories & More",
    //   dropdown: true,
    //   onClick: handleAccessoriesClick,
    // },

  
    {
      path: "/hospitality",
      label: "Hospitality",
      dropdown: true,
      onClick: handleHospitalityClick,
    },
    { path: "/contact-us", label: "Contact Us" },
  ];

  const dispatch = useDispatch();

  const categoriesData = useSelector((state) => state.master.categories);
  const subcategoriesData = useSelector((state) => state.master.subcategories);

  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const app_setup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  useEffect(() => {
    if (categoriesData?.length > 0) {
      setSelectedCategory(categoriesData[0]?.id);

      dispatch(getAllSubCategory({ category_id: categoriesData[0]?.id }));
    }
  }, [categoriesData]);

  const handleClickCategory = async (category_id, subCatExist) => {
    setSelectedCategory(category_id);
    await dispatch(getAllSubCategory({ category_id }));
  };

  // console.log("subcategoriesData", subcategoriesData);

  const categoryData = categoriesData?.map((item) => {
    return {
      catName: item?.name,
      catImage: item?.image,
      catId: item?.id,
      subcat: item?.p_sub_categories?.map((sub) => {
        return {
          subCatName: sub?.name,
          subCatId: sub?.id,
          ...sub,
        };
      }),
    };
  });

  const categoryData2 = categoriesData?.map((item) => {
    const matchedSubcategories = subcategoriesData
      ?.filter((sub) => sub?.p_category?.id === item?.id)
      ?.map((sub) => ({
        subCatName: sub?.name,
        subCatId: sub?.id,
        ...sub,
      }));

    return {
      catName: item?.name,
      catId: item?.id,
      subcat:
        matchedSubcategories?.length > 0 ? matchedSubcategories : undefined,
    };
  });

  // console.log("categoryData2", categoryData2);

  const hospitalityNav = [
    {
      catName: "Hotel Bliss Mattress",
      catId: 1,
      link: "/hospitality",
    },
    {
      catName: "Hotel Comfort Mattress",
      catId: 2,
      link: "/hospitality",
    },
  ];

  const headersData = useSelector((state) => state.home.headers);
  useEffect(() => {
    dispatch(getHomeHeader());
  }, [dispatch]);

  const allWishlist = useSelector((state) => state.wishlist.allWishlist);
  useEffect(() => {
    dispatch(getAllWishlist());
  }, [dispatch]);

  const isSignIn = useSelector((state) => state.auth.is_signin);

  const cart = useSelector((state) => state.cart.allCarts);

  useEffect(() => {
    dispatch(getAllCart(isSignIn));
  }, []);

  // useEffect(() => {
  //   dispatch(myAccount());
  // }, []);

  const [expanded, setExpanded] = useState(false);

  console.log(headersData, "headersData headersData");

  return (
    <>
      <section className="Header">
        {/* Top header */}
        <div className="top_headers_holder">
          <div className="top_header">
         
              <div className="top_header_bar thnk_col_2">
                  <marquee className="" >
                    <div className="top_header_col1 d-flex gap-5 " >
                  {headersData?.map((val, index) => (
                   
                        <div className="content_html " key={index} >
                          {val?.name1 || "Welcome To Majesty Mattress"}
                        </div>
                    
                  ))}
                  </div>
                  </marquee>

                {/* <div className="top_header_bar">
                  <div className="top_header_col1">
                    <p className="content_html">
                      Lorem Ipsum Is Simply Dummy Text Of
                    </p>
                  </div>
                </div> */}
              </div>
          
          </div>

          {/* Middle header */}
          <div className="middle_header">
            <div className="container">
              <div className="all_divs_holder">
                {/* Logo */}
                <div className="logo_div" onClick={() => navigate("/")}>
                  <img
                    // src="/assets/images/logo/logo.png"
                    src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
                    className="logo_img"
                    alt="logo"
                  />
                </div>

                {/* Right side icons */}
                <div className="three_box_div ">
                  <>
                    <div className="box_div search_box">
                      <div
                        className="search_div"
                        onClick={() => {
                          setShowSearch(true);
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faMagnifyingGlass}
                          className="search_icon"
                        />
                      </div>
                    </div>
                    <div
                      className="box_div border_box"
                      onClick={() => navigate("/cart")}
                    >
                      {/* <p className="title_text"> Cart</p> */}
                      <div className="inner_count_div">
                        <p className="count_text">
                          {cart?.data?.length > 0 ? cart?.data?.length : 0}
                        </p>
                        <p className="icon_text">
                          <FontAwesomeIcon
                            icon={faCartShopping}
                            className="inner_icon"
                          />
                        </p>
                      </div>
                    </div>
                    <div
                      className="box_div border_box"
                      onClick={() => navigate("/wishlist")}
                    >
                      {/* <p className="title_text"> Wishlist</p> */}
                      <div className="inner_count_div">
                        <p className="count_text">
                          {allWishlist?.data?.length || 0}
                        </p>
                        <p className="icon_text">
                          <FontAwesomeIcon
                            icon={faHeart}
                            className="inner_icon"
                          />
                        </p>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom header */}
        <div className="bottom_header">
          <div className="container">
            <div className="two_box_holder">
              <div className="box1">
                <Navbar
                  expand="lg"
                  expanded={expanded}
                  onToggle={() => setExpanded(!expanded)}
                >
                  {/* <div className="menu_toggle">
                    <button >
                      <FontAwesomeIcon icon={faBars} className="menu_icon" />{" "}
                      MENU
                    </button>
                  </div> */}

                  <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                      {navLinks.map((link) => (
                        <Nav.Link
                          key={link.label}
                          as={Link}
                          to={link.path}
                          active={isActive(link.path)}
                          onClick={(e) => {
                            if (link.dropdown) {
                              e.preventDefault(); // prevent navigation
                              link.onClick && link.onClick();
                            }
                            setExpanded(false);
                          }}
                        >
                          <div className="inner_nav">
                            <p className="link_text">{link.label}</p>
                            {link?.dropdown && (
                              <p className="inner_icon">
                                <FontAwesomeIcon
                                  icon={faSortDown}
                                  className="icon_text"
                                />
                              </p>
                            )}
                          </div>
                        </Nav.Link>
                      ))}
                    </Nav>
                  </Navbar.Collapse>
                </Navbar>
              </div>

              <div className="box2">
                <div className="common_icon_holder mobile_d_none">
                  <FontAwesomeIcon icon={faPhone} className="call_icon" />
                </div>
                <div className="text_holder mobile_d_none">
                  <p className="first_text">Call To</p>
                  <p className="number_text">{app_setup?.contact_no}</p>
                </div>

                {isSignIn ? (
                  <Nav.Link as={Link} to={"/my-profile"}>
                    <div className="common_icon_holder profile_icon_holder">
                      <FontAwesomeIcon icon={faUser} className="call_icon" />
                    </div>
                  </Nav.Link>
                ) : (
                  <Nav.Link
                    onClick={() => {
                      setShowLoginModal(true);
                    }}
                  >
                    Login
                  </Nav.Link>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Offcanvas */}
        <Offcanvas show={false} onHide={() => {}} className="menu_offcanvas">
          <Offcanvas.Header closeButton />
          <Offcanvas.Body>
            <Navbar expand="lg">
              <Nav className="me-auto">
                {navLinks.map((link) => (
                  <Nav.Link
                    key={link.path}
                    as={Link}
                    to={link.path}
                    // active={isActive(link.path)}
                  >
                    {link.label}
                  </Nav.Link>
                ))}
              </Nav>
            </Navbar>
          </Offcanvas.Body>
        </Offcanvas>

        {/* <Use_Current_Location
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
        <Delete_Contact_Modal
          modal_title="Log Out"
          message="Are you sure, you want to Log Out?"
          show={showLogoutModal}
          onHide={() => setshowLogoutModal(false)}
          yesAction={() => setIsLogedIn(false)}
          noAction={() => setshowLogoutModal(false)}
        />
        */}

        <Login_Modal
          show={showLoginModal}
          onHide={() => setShowLoginModal(false)}
          loginDone={() => setIsLogedIn(true)}
          setShowResetModal={() => setShowResetModal(true)}
          setShowAccountCreted={() => setShowAccountCreted(true)}
        />
        <Reset_Password_Modal
          email={email}
          setEmail={setEmail}
          contact={contact}
          setContact={setContact}
          show={showResetModal}
          onHide={() => setShowResetModal(false)}
          setShowSetPassModal={() => setShowSetPassModal(true)}
        />
        <Set_New_Password_Modal
          email={email}
          setEmail={setEmail}
          contact={contact}
          setContact={setContact}
          show={showSetPassModal}
          onHide={() => setShowSetPassModal(false)}
        />

        <Common_Category_Offcanvas
          placement="start"
          show={showCategories}
          onHide={() => {
            setShowCategories(false);
          }}
          navs={categoryData}
          handleClickCategory={handleClickCategory}
          setActiveIndex={setActiveIndex}
          activeIndex={activeIndex}
        />

        <Common_Category_Offcanvas
          placement="start"
          show={showHospitality}
          onHide={() => {
            setShowHospitality(false);
          }}
          navs={hospitalityNav}
          handleClickCategory={handleClickCategory}
          setActiveIndex={setActiveIndex}
          activeIndex={activeIndex}
        />

        <Search_Product_Offcanvas
          placement="top"
          show={showSearch}
          onHide={() => {
            setShowSearch(false);
          }}
        />
      </section>
    </>
  );
}

export default Header;
